var React = require('react');

function HeaderApplat (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"applat","d":"M-20405.42,3863.591c-73.617.417-103.064,105.292-154.264,147.55s-116.4,2.967-143.373,55.218,3.184,112.662,23.816,146.946,114.156,133.27,204.887,134.228,196.859-44.383,228.393-177.6C-20214.426,4036.687-20331.8,3863.174-20405.42,3863.591Z","transform":"matrix(0.035, 0.999, -0.999, 0.035, 5067.8, 20566.283)","fill":"#ffe17c"}));
}

HeaderApplat.defaultProps = {"width":"500.172","height":"489.645","viewBox":"0 0 500.172 489.645"};

module.exports = HeaderApplat;

HeaderApplat.default = HeaderApplat;
